module.exports = __webpack_public_path__ + "media/images/black_history_month/transparent-okra-e09a1cb8c4a53ff14b40d2f527d4b934.png";